import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

const FormattedMessageCapitalized = ({id, messageClasses}) => {
    const spanClasses = classNames({
        'text-uppercase': true,
        [messageClasses]: messageClasses
    });
    return (
        <span className={spanClasses}>
            <FormattedMessage id={id} />
        </span>
    );
};

export default FormattedMessageCapitalized;
